
import axios from "axios";
import {environmentDetails} from "../environment/environment";
import { refreshTokenHeadersObject } from "./headers";
const apiUrl = environmentDetails.apiUrl;


export const generateNewAccessToken = ()=>{
       return axios.post(`${apiUrl}questionnaire/refreshToken`,{},{headers:refreshTokenHeadersObject()});
  // return axios.post(`http://localhost:4000/questionnaire/refreshToken`,{},{headers:refreshTokenHeadersObject()});
}
